/* globals document, $, config, location */

$(document).ready(async () => {
    $('#create-user-button').on('click', async () => {
        const input = $('#create-user-input');

        const username = input.val();

        $.ajax({
            url: config.relative_path + '/sal/create-user',
            type: 'POST',
            data: { username },
            success: () => {
                location.reload();
            },
            error: () => {
                console.log('ERROR!');
            }
        });
    });
});